import styled from 'styled-components';
import { IonGrid } from '@ionic/react';

export const IonGridWrapper = styled(IonGrid)`
  .img-row {
    align-items: center;
  }

  .media-capture-button {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
`;
